import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { NoResult, BookMarkStore, Alert, ComPhoto, BuyerPopup, BannerAd, Confirm } from '../../../js/ComponentManager'
/* 개발담당: 양유빈
 * 화면기능: 스토어주문메인
 * 세부설명:
*/

export class OrderStoreList extends Component {
    static displayName = OrderStoreList.name;

    constructor(props) {
        super(props);
        this.state = {
            BldList: [],
            Bld_Code: "",
            Bld_Name: "",
            Bld_Hide: false,
            FlrList: [],
            Flr_Code: "",
            Flr_Name: "",
            WholeList: [],
            OrderList: [],
            Bill_Yn: "N",
            Refund_Yn: "N",
            Title: "",
            Content: "",
            SearchText:""
        };
        this.CsName = Big3Common.ContentState;
        this.ref_BuyerPopup = React.createRef();
        this.TempFlrList = [];
        this.handleBld_Click = this.handleBld_Click.bind(this);
        this.handleFlr_Clik = this.handleFlr_Clik.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleBuyer_Click = this.handleBuyer_Click.bind(this);
        this.handleCancel_Click = this.handleCancel_Click.bind(this);
        this.GetAlreadyOrder = this.GetAlreadyOrder.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
        
    }
    //초기화
    componentDidMount() {
        this.DefaultData();
        this.GetAlreadyOrder();
        if (this.Uid_Type === 'TS') {
            /*this.GetRefund();*/
            this.GetbillingKey();
        }
    }
    async DefaultData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get("api/Common/Common/BldMgt");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataSet = JSON.parse(Data.multiDataTable);
                const BldList = DataSet.BldList;
                this.TempFlrList = DataSet.FlrList;
                this.setState({
                    BldList: BldList
                });
            }
        }
        catch (e) {
            console.log("DefaultData :", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    async GetAlreadyOrder() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/MyPage/OrderMgr/GetAlreadyOrder", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const OrderList = JSON.parse(Data.dataTable);
                this.setState({
                    OrderList: OrderList
                });
            }
        }
        catch (e) {
            console.log("GetAlreadyOrder :", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //도매상가 검색
    async GetWholeSearch(BldCode, FlrCode, WholeNoName, Wholename) {
        try {

            let Model = {
                Bld_Code: BldCode,
                flr_Code: FlrCode,
                Whole_No_Name: WholeNoName.replaceAll('호', ''),
                whole_name: Wholename
            };
            if (BldCode === "" && FlrCode==="" && Wholename === "") {
                return [];
            }
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/Common/Common/GetBldWholeSearch", Model, true);
           
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = Data.objectData
                if (DataSet === undefined) {
                    DataSet = JSON.parse(Data.dataTable);
                }
                return DataSet;
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetWholeSearch :", e);
        }
        finally {
            document.querySelector("input").blur();
            Big3Common.Util.LoadingOff();
        }
    }
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }*/
    //빌딩목록 클릭
    handleBld_Click(event, listData) {
        Big3Common.Util.LoadingOn();
        const FlrList = this.TempFlrList.filter(list => list.bld_code === listData.bld_code);
        setTimeout(() => {
            this.setState({
                Bld_Code: listData.bld_code,
                Bld_Name: listData.bld_name,
                FlrList: FlrList,
                Bld_Hide: true
            });
            Big3Common.Util.LoadingOff();
        }, 700);
    }
    //층 클릭
    async handleFlr_Clik(event, listData) {
        const WholeList = await this.GetWholeSearch(this.state.Bld_Code, listData.flr_code, "", "");
        this.setState({
            Flr_Code: listData.flr_code,
            Flr_Name: listData.flr_name,
            WholeList: WholeList
        });
        event.preventDefault();
    }
    //검색조건 초기화
    handleClear_Click(event) {
        if (this.state.BldList.length > 0 && this.state.FlrList.length > 0 && this.state.WholeList.length > 0) {
            this.setState({
                WholeList: [],
                SearchText: ""
            });
        }
        else {
            this.setState({
                Bld_Code: "",
                Bld_Name: "",
                Bld_Hide: false,
                FlrList: [],
                Flr_Code: "",
                Flr_Name: "",
                WholeList: [],
                SearchText: ""
            });
        }        
        event.preventDefault();
    }
    async handleSearch_Change(event) {
        let Value = event.target.value;
        //검색 조건이 없이 이벤트가 발생하면 전체를 검색해 줌.
        //if (Value === "") {
        //    const WholeList = await this.GetWholeSearch(this.state.Bld_Code, this.state.Flr_Code, "", "");
        //    this.setState({
        //        Bld_Code: "",
        //        Bld_Name: "",
        //        Bld_Hide: false,
        //        WholeList: WholeList,
        //        SearchText: Value
        //    });
        //}
        this.setState({ SearchText: Value });
        event.preventDefault();
    }
    //도매상가 검색 엔터
    async handleSearch_Click(event) {
        if (event.keyCode === 13) {
            
            if (this.state.SearchText.trim() === "") {
                this.setState({ Title: "도매명을 입력하여 주세요." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            const WholeList = await this.GetWholeSearch(this.state.Bld_Code, this.state.Flr_Code, "", this.state.SearchText);
            if (WholeList.length === 0) {
                this.setState({ Title: "검색 결과가 없습니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            this.setState({
                WholeList: WholeList,
                Bld_Hide: WholeList.length > 0 ? true: false,
            });
        }
        event.preventDefault();
    }
    //사입요청
    handleBuyer_Click(event, whole_code) {
        if (this.Uid_Type === 'SS') {
            this.ref_BuyerPopup.current.initWholeCode(whole_code)
            Big3Common.ModalAlert(bootstrap, 'BuyerPopup');
            event.preventDefault();
        }
        else {
            if (this.state.Bill_Yn === 'N') {
                this.setState({ Title: "카드 등록 후 주문이 가능합니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
/*            else if (this.state.Refund_Yn === 'Y') {
                this.setState({ Title: "환불 진행중에는 주문이 불가능합니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }*/
            else if (this.state.Bill_Yn === 'Y' && this.state.Refund_Yn === 'N') {
                this.ref_BuyerPopup.current.initWholeCode(whole_code)
                Big3Common.ModalAlert(bootstrap, 'BuyerPopup');
                event.preventDefault();
            }
        }
    }
    handleAlert(event) {
        this.setState({
            Title: "택배주문안내",
            Content: "택배주문은 장바구니에서 가능합니다."
        });
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        event.preventDefault();
    }
    //주문취소
    DeleteModel = {
        uid: "",
        ordgrp_no: "",
        order_code: "",
        whole_code: "",
        type: "",
        ord_dt: ""
    };
    handleCancel_Click(DelData, Type) {

        if (Type === "SP") {
            //상품리스트 삭제 클릭
            this.DeleteModel.uid = DelData.uid;
            this.DeleteModel.ordgrp_no = DelData.ordgrp_no;
            this.DeleteModel.ord_dt = DelData.order_dt;
            this.DeleteModel.type = Type;
        }
        else {
            //사입내역 삭제 클릭
            this.DeleteModel.order_code = DelData[0].order_code;
            this.DeleteModel.ord_dt = DelData[0].order_dt;
            this.DeleteModel.whole_code = DelData[0].whole_code;
            this.DeleteModel.type = Type;
        }
        Big3Common.ModalAlert(bootstrap, "CancelConfirm");
        return false;
    }
    //취소처리 Rest전송--> Confirm창 취소 실행
    async handleCancel_Post() {
        try {
            let Data = await Big3Common.Post('api/MyPage/OrderMgr/CancelOrdMgt', this.DeleteModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "CompleteCancel");
                await this.GetAlreadyOrder();
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handleCancel_Post", e);
        }
        finally {
            this.DeleteModel.uid = "";
            this.DeleteModel.ordgrp_no = "";
            this.DeleteModel.order_code = "";
            this.DeleteModel.type = "";
        }
        return false;

    }
    //빌딩목록
    Builrender() {
        if (this.state.Bld_Hide===true) {
            return false;
        }
        const BldList = this.state.BldList;
        return (
            <div className="recent_product recent_product_v2">
                <div className="shop_center_select_box row row-cols-3">
                    {BldList.map(list =>
                        <div className={list.bld_code === this.state.Bld_Code ? "shop selected" : "shop"} key={list.bld_code}
                            onClick={(e) => { this.handleBld_Click(e, list); }}>{list.bld_name}</div>
                    )}
                </div>
            </div>
        )
    }
    //층목록
    Flrrender() {
        if (this.state.WholeList.length > 0) {
            return false;
        }
        const FlrList = this.state.FlrList;
        if (FlrList.length === 0) return false;
        const Bld_Name = this.state.Bld_Name;

        return (
            <div className="recent_product recent_product_v2">
                <div className="title_box">
                    <div className="title">상가 · {Bld_Name ||""}</div>
                    <div className="category_box reset">
                        <div className="category" onClick={(e) => { this.handleClear_Click(e) }}>초기화</div>
                        <div className="reset_btn"></div>
                    </div>
                </div>
                <div className="shop_center_select_box row row-cols-3">
                    {
                        FlrList.map(list =>
                            <div className={list.flr_code === this.state.Flr_Code ? "shop shop_v2 selected" : "shop shop_v2"} key={list.flr_code}
                                onClick={(e) => { this.handleFlr_Clik(e, list); }}>{list.flr_name}</div>
                        )
                    }
                </div>
            </div>
        )
    }
    Wholerender() {
        const WholeList = this.state.WholeList;
        const OrderList = this.state.OrderList;
        if (WholeList.length === 0) {
            return false;
        }
        const Bld_Name = this.state.Bld_Name;
        const Flr_Name = this.state.Flr_Name;
        let Bld_Name_Title = "";
        if (Bld_Name !== "" && Flr_Name === "") {
            Bld_Name_Title = `상가 · ${Bld_Name}`;
        }
        else if (Bld_Name !== "" && Flr_Name === "") {
            Bld_Name_Title = `상가 · ${Bld_Name} · ${Flr_Name }`;
        }
        let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        
        //상품이미지 링크
        this.GoodsPhoto_Link = (list) => {
            if (list.uid === "" || list.uid === null) {
                return (
                    <div className="alert_img">
                        <ComPhoto className="alert_img_in" />
                    </div>
                )
            }
            else {
                return (
                    <Link to={`/Search/Goods/Index?Uid=${list.uid}`}>
                        <div className="alert_img">
                            <ComPhoto className="alert_img_in" Photo={Big3Common.Util.isEmptyOrNull(list.photo) === true ? "" : VirtualRoot + list.photo} />
                        </div>
                    </Link>
                )
            }
        }
        //상가명과 홈페이지 이동 링크
        this.Home_Link = (list) => {
            if (list.uid === "" || list.uid === null) {
                return (
                    <div className="shop_name">{list.whole_name}
                    </div>
                )
            }
            else {
                return (
                    <Link to={`/Search/Goods/Index?Uid=${list.uid}`}>
                        <div className="shop_name">{list.whole_name}
                            <span className="go_s"></span>
                        </div>
                    </Link>
                )
            }
        }
        //채팅이동
        this.Chat_Link=(list)=> {
            if (list.uid === "" || list.uid === null) {
                return (
                   ""
                )
            }
            else {
                return (
                    <Link to={`/Chat/LiveChat/Index?uid=${list.uid}`}>
                        <div className="chat_icon3"></div>
                    </Link>
                )
            }
        }
        return (
            <div className="recent_product recent_product_v2">
                <div className="title_box">
                    <div className="title">{Bld_Name_Title}</div>
                    <div className="category_box reset">
                        <div className="category" onClick={(e) => {this.handleClear_Click(e) } }>초기화</div>
                        <div className="reset_btn"></div>
                    </div>
                </div>
                {
                    WholeList.map(list =>
                        <div className="alert_content_v2 alert_content" key={list.whole_code}>
                            {this.GoodsPhoto_Link(list) }
                            <div className="alert_txt">
                                {this.Home_Link(list) }
                                <div className="shop_address">{list.bld_name} {list.flr_name}층 {list.whole_no_name}호</div>
                                <BookMarkStore
                                    Whole_Code={list.whole_code}
                                    HeartOn={list.bookmark_yn === "Y" ? true : false}
                                />
                                {
                                    OrderList.some(order => String(order.whole_code) === String(list.whole_code)) ? (
                                        <div className="order_btn or_btn4 btn_v2" onClick={() => { this.handleCancel_Click(OrderList, 'SI') }}>주문취소</div>
                                    ) : (
                                        this.Uid_Type === 'SS' ? (
                                            <div className="order_btn or_btn4"
                                                onClick={(e) => { this.handleBuyer_Click(e, list.whole_code) }}
                                            >사입요청</div>
                                        ) : (
                                            <div className="order_btn or_btn4"
                                                onClick={(e) => { this.handleBuyer_Click(e, list.whole_code) }}
                                            >픽업요청</div>
                                        )
                                    )
                                }
                                {this.Chat_Link(list) }
                            </div>
                        </div>
                    )
                }
                <NoResult
                    Visible={this.state.WholeList.length === 0 ? true : false}
                    Top={"60%"}
                />
            </div>
        )
    }
    render() {
        const Builrender = this.Builrender();
        const Flrrender = this.Flrrender();
        const Wholerender = this.Wholerender();
        return (
            <div>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap"><div className="alert_tap   tap_on">스토어</div></div>
                    <div className="n_tap" onClick={() => { this.props.RenderComponent("OrderExcelList"); }}><div className="alert_tap" >일괄주문</div></div>
                </div>
                <div className="m_f_margin d_padding container_box">
                    <div className="search_box_v3">
                        <input type="search"
                            inputMode="search"
                            enterKeyHint="search"
                            placeholder="도매 상가명을 검색해주세요"
                            className="form-control"
                            onKeyUp={(e) => { this.handleSearch_Click(e) }}
                            onChange={this.handleSearch_Change}
                            value={this.state.SearchText}
                        />
                        <div className="search_icon"></div>
                        <div className="search_delete" onClick={(e) => { this.handleClear_Click(e) }}></div>
                    </div>
                    <BannerAd id="BasketBanner" ads_loc_cd="OS" ads_type_detail_cd="SB" />
                    {Builrender }
                    {Flrrender}
                    {Wholerender }
                </div>
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                />
                <BuyerPopup
                    id="BuyerPopup"
                    ref={this.ref_BuyerPopup}
                    CallBack={this.GetAlreadyOrder}
                />
                <Alert
                    id="CompleteCancel"
                    content={this.state.Content}
                    title="취소완료"
                />
                <Confirm
                    id="CancelConfirm"
                    title="취소 하시겠습니까?"
                    content="완료되지 않은 사입내역이 존재하면<br/> 사입내역까지 취소 합니다."
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'CancelConfirm');
                        }, 500);
                        this.handleCancel_Post()
                    }}
                />
            </div>
        );
    }
}
